// extracted by mini-css-extract-plugin
export default {"main":"with-card_main__aeV6e","items":"with-card_items__23zEa"};